// @ts-nocheck


import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

import Modal from '../../../../components/ant/Modal';
import Button from 'antd/lib/button';
import InputNumber from 'antd/lib/input-number';

import {
  toLocalStringRu,
  MONTH,
  tooltipFullText,
  plus,
  minus } from
'../../../../lib/helpers';

import { branchBudgetSummaryMonthRedistributionApi } from '../../../../lib/api';

import Field from '../../../../components/card/Field';
import { AntTable } from '../../../../components/ui';
import Grid, { GridItem } from '../../../../components/layout/Grid';
import { Selects } from '../../../../components';

const {
  BranchBudgetSummaryLineItemSelect,
  BranchBudgetSummaryExpenseDirectionSelect,
  BranchBudgetSummaryMonthSelect
} = Selects;

export const StyledInputNumber = styled(InputNumber).withConfig({ displayName: "DistributionEconomyModal__StyledInputNumber", componentId: "sc-712xua-0" })(["width:100%;"]);


const WhiteSpace = styled.div.withConfig({ displayName: "DistributionEconomyModal__WhiteSpace", componentId: "sc-712xua-1" })(["white-space:pre-line;overflow:auto;"]);



const StyledTable = styled(AntTable).withConfig({ displayName: "DistributionEconomyModal__StyledTable", componentId: "sc-712xua-2" })([""]);











export default ({
  visible,
  onCancel,
  onSave,
  branchBudgetSummaryLineItem,
  branchBudgetSummaryId,
  monthIndex,
  monthToId,
  readOnly
}) => {
  const [budget, setBudget] = useState(branchBudgetSummaryLineItem);
  const [economyTransfer, setTransfer] = useState(0);
  const [redistributionData, setRedistributionData] = useState([]);
  const [data, setData] = useState([]);
  const [transferData, setTransferData] = useState({});

  const getRedistributionData = async () => {
    const { data } = await branchBudgetSummaryMonthRedistributionApi.fetch({
      monthToId
    });
    setRedistributionData(data);
  };

  const clearTransferData = (field) => {
    switch (field) {
      case 'branchBudgetSummaryLineItem':
        setTransferData((prevState) => ({
          ...prevState,
          branchBudgetSummaryExpenseDirectionId: undefined,
          expenseDirectionNameFrom: undefined,
          branchBudgetSummaryExpenseDirection: undefined
        }));
      case 'branchBudgetSummaryExpenseDirection':
        setTransferData((prevState) => ({
          ...prevState,
          monthToId: undefined,
          monthFromId: undefined,
          monthFromIndex: undefined,
          branchBudgetSummaryMonthId: undefined,
          branchBudgetSummaryMonth: undefined
        }));
      default:
        break;
    }
  };

  useEffect(() => {
    setBudget(branchBudgetSummaryLineItem);
  }, [branchBudgetSummaryLineItem, monthIndex]);

  useEffect(() => {
    if (Number.isInteger(monthToId)) {
      getRedistributionData();
    }
  }, [getRedistributionData, monthToId]);

  return (
    <Modal
      destroyOnHidden
      width={1200}
      title="Покрытие потребности"
      visible={visible}
      onCancel={() => {
        onCancel();
      }}
      onOk={() => {
        onSave(data, redistributionData);
        setData([]);
      }}>

      {readOnly !== true &&
      <>
          <StyledTable
          columns={[
          {
            title:
            <div>
                    Статья бюджетной форм
                    <br />
                    куда производится перенос
                  </div>,

            dataIndex: 'budgetLineItemName',
            render: (budgetLineItemName) =>
            <WhiteSpace>
                    {tooltipFullText(budgetLineItemName, 35)}
                  </WhiteSpace>

          },
          {
            title:
            <div>
                    Направление расходов
                    <br />
                    куда производится перенос
                  </div>,

            dataIndex: 'expenseDirectionName',
            render: (expenseDirectionName) =>
            <WhiteSpace>
                    {tooltipFullText(expenseDirectionName, 35)}
                  </WhiteSpace>

          },
          {
            title:
            <div>
                    Месяц на который
                    <br />
                    производится перенос
                  </div>,

            dataIndex: 'months',
            render: (months) => MONTH[monthIndex]
          },
          {
            title: <div>Итого перерасход</div>,
            dataIndex: 'months',
            key: 'economyResidue',
            render: (months, record) =>
            toLocalStringRu(record.months[monthIndex].economyResidue)
          },
          {
            title: <div>Покрытый перерасход</div>,
            dataIndex: 'months',
            render: (months) => toLocalStringRu(economyTransfer)
          },
          {
            title: <div>Непокрытый перерасход</div>,
            dataIndex: 'months',
            render: (months, record) =>
            toLocalStringRu(
              minus(
                record.months[monthIndex].economyResidue,
                economyTransfer
              )
            )
          }]
          }
          data={[budget]}
          pagination={false} />

          <Grid
          style={{
            marginTop: 16,
            paddingTop: 16,
            borderTop: '1px solid #c0ccd7'
          }}
          gutter="16px">

            <GridItem>
              <Field>
                <BranchBudgetSummaryLineItemSelect
                filter={{
                  withEconomy: true,
                  branchBudgetSummaryId: branchBudgetSummaryId
                }}
                value={transferData?.branchBudgetSummaryLineItemId}
                onChange={(
                branchBudgetSummaryLineItemId,
                option) =>
                {
                  clearTransferData('branchBudgetSummaryLineItem');
                  setTransferData((prevState) => ({
                    ...prevState,
                    branchBudgetSummaryLineItemId,
                    budgetLineItemNameFrom:
                    option?.props?.branchBudgetSummaryLineItem?.
                    budgetLineItemName,
                    branchBudgetSummaryLineItem:
                    option?.props?.branchBudgetSummaryLineItem
                  }));
                }} />

              </Field>
            </GridItem>
            <GridItem>
              <Field>
                <BranchBudgetSummaryExpenseDirectionSelect
                value={transferData?.branchBudgetSummaryExpenseDirectionId}
                disabled={!transferData?.branchBudgetSummaryLineItemId}
                onChange={(
                branchBudgetSummaryExpenseDirectionId,
                option) =>
                {
                  clearTransferData('branchBudgetSummaryExpenseDirection');
                  setTransferData((prevState) => ({
                    ...prevState,
                    branchBudgetSummaryExpenseDirectionId,
                    expenseDirectionNameFrom:
                    option?.props?.branchBudgetSummaryExpenseDirection?.
                    expenseDirectionName,
                    branchBudgetSummaryExpenseDirection:
                    option?.props?.branchBudgetSummaryExpenseDirectionn
                  }));
                }}
                filter={{
                  withEconomy: true,
                  branchBudgetSummaryLineItemId:
                  transferData?.branchBudgetSummaryLineItemId
                }} />

              </Field>
            </GridItem>
            <GridItem>
              <Field>
                <BranchBudgetSummaryMonthSelect
                value={transferData?.branchBudgetSummaryMonthId}
                disabled={
                !transferData?.branchBudgetSummaryExpenseDirectionId
                }
                onChange={(
                branchBudgetSummaryMonthId,
                option) =>
                {
                  setTransferData((prevState) => ({
                    ...prevState,
                    monthToId: budget.months[monthIndex].id,
                    monthFromId: branchBudgetSummaryMonthId,
                    monthFromIndex:
                    option?.props?.branchBudgetSummaryMonth?.month,
                    branchBudgetSummaryMonthId,
                    isOpenPeriod:
                    option?.props?.branchBudgetSummaryMonth?.isOpenPeriod,
                    branchBudgetSummaryMonth:
                    option?.props?.branchBudgetSummaryMonth
                  }));
                }}
                filter={{
                  withEconomy: true,
                  branchBudgetSummaryExpenseDirectionId:
                  transferData?.branchBudgetSummaryExpenseDirectionId
                }} />

              </Field>
            </GridItem>
            <GridItem>
              <Field>
                <StyledInputNumber
                disabled={!transferData?.branchBudgetSummaryMonthId}
                placeholder="Укажите сумму"
                value={transferData?.sum}
                min={0}
                onChange={(sum) => {
                  if (
                  sum <=
                  Math.abs(
                    plus(
                      budget.months[monthIndex].economyResidue,
                      economyTransfer
                    )
                  ))
                  {
                    setTransferData((prevState) => ({
                      ...prevState,
                      sum
                    }));
                  }
                }} />

              </Field>
            </GridItem>
            <GridItem>
              <Field>
                <Button
                type="primary"
                disabled={
                !transferData?.sum ||
                !transferData?.branchBudgetSummaryMonthId ||
                !transferData?.branchBudgetSummaryExpenseDirectionId ||
                !transferData?.branchBudgetSummaryLineItemId
                }
                onClick={() => {
                  setTransfer(plus(economyTransfer, transferData.sum));
                  setData([
                  ...data,
                  {
                    ...transferData
                  }]
                  );
                  setTransferData({});
                }}>

                  Применить
                </Button>
              </Field>
            </GridItem>
          </Grid>
        </>
      }
      <Grid style={{ marginTop: 16 }}>
        <GridItem style={{ fontWeight: 'bold' }}>
          Покрытие расходов из экономии открытого период
        </GridItem>
        <GridItem fullWidth style={{ marginTop: 16 }}>
          <StyledTable
            columns={[
            {
              title: 'Статья бюджетной формы',
              dataIndex: 'budgetLineItemNameFrom',
              render: (budgetLineItemName) =>
              <WhiteSpace>
                    {tooltipFullText(budgetLineItemName, 35)}
                  </WhiteSpace>

            },
            {
              title: 'Направление расходов',
              dataIndex: 'expenseDirectionNameFrom',
              render: (expenseDirectionName) =>
              <WhiteSpace>
                    {tooltipFullText(expenseDirectionName, 35)}
                  </WhiteSpace>

            },
            {
              title: 'Месяц',
              dataIndex: 'monthFromIndex',
              render: (month) => MONTH[month - 1]
            },
            {
              title: 'Перенесенная сумма',
              dataIndex: 'sum',
              key: 'sum',
              render: (sum) => toLocalStringRu(sum)
            }]
            }
            data={[...redistributionData, ...data].filter(
              (item) => item.isOpenPeriod === true
            )}
            pagination={false} />

        </GridItem>
      </Grid>

      <Grid style={{ marginTop: 16 }}>
        <GridItem style={{ fontWeight: 'bold' }}>
          Покрытие расходов из экономии закрытого периода
        </GridItem>
        <GridItem fullWidth style={{ marginTop: 16 }}>
          <StyledTable
            columns={[
            {
              title: 'Статья бюджетной формы',
              dataIndex: 'budgetLineItemNameFrom',
              render: (budgetLineItemName) =>
              <WhiteSpace>
                    {tooltipFullText(budgetLineItemName, 35)}
                  </WhiteSpace>

            },
            {
              title: 'Направление расходов',
              dataIndex: 'expenseDirectionNameFrom',
              render: (expenseDirectionName) =>
              <WhiteSpace>
                    {tooltipFullText(expenseDirectionName, 35)}
                  </WhiteSpace>

            },
            {
              title: 'Месяц',
              dataIndex: 'monthFromIndex',
              render: (month) => MONTH[month - 1]
            },
            {
              title: 'Перенесенная сумма',
              dataIndex: 'sum',
              key: 'sum',
              render: (sum) => toLocalStringRu(sum)
            }]
            }
            data={[...redistributionData, ...data].filter(
              (item) => item.isOpenPeriod === false
            )}
            pagination={false} />

        </GridItem>
      </Grid>
    </Modal>);

};
